import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { useUIStore } from '@/stores/ui.store'

export function AdminLayout() {
    const sidebarCollapsed = useUIStore((s) => s.sidebarCollapsed)

    return (
        <div className="min-h-screen bg-surface-50">
            <Sidebar />
            <div
                className={`
          transition-all duration-300
          ${sidebarCollapsed ? 'lg:ml-[72px]' : 'lg:ml-[260px]'}
        `}
            >
                <Header />
                <main className="p-4 lg:p-6 animate-fade-in">
                    <Outlet />
                </main>
            </div>
        </div>
    )
}
